// Full-screen takeover shown when a workspace is suspended by Noordzuid.
// Dashboard mounts this instead of the normal shell when the brand API
// returns 423 Locked. Super-admins impersonating still see the real UI
// (require_brand_access returns early for them).
import { PauseCircle } from "lucide-react";

export default function SuspendedScreen({ brandName }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f8f8f6] px-6" data-testid="suspended-screen">
      <div className="max-w-md text-center">
        <PauseCircle className="w-10 h-10 text-amber-500 mx-auto mb-4" strokeWidth={1.5} />
        <div className="text-[11px] uppercase tracking-widest text-gray-400 mb-2">Workspace op pauze</div>
        <h1 className="font-display text-3xl font-medium text-[#1a1a1a] mb-3">
          {brandName || "Deze workspace"} is tijdelijk op pauze gezet
        </h1>
        <p className="text-sm text-gray-500 leading-relaxed">
          Noordzuid heeft deze workspace tijdelijk gepauzeerd. Neem contact op met Noordzuid als dit niet klopt — je toegang keert direct terug zodra de pauze is opgeheven.
        </p>
      </div>
    </div>
  );
}
